import styled from '@emotion/styled'
import { AutoCompleteProps, Select } from 'antd'
import { useEffect, useState } from 'react'

type SelectProps = {
  label: string
  data: string[]
  titleOption?: string
} & AutoCompleteProps

export const SelectComponent = (props: SelectProps) => {
  const [hasValue, setHasValue] = useState(!!props.value)
  const [hasFocus, setHasFocus] = useState(false)
  const [hasDisabled, setHasDisabled] = useState(false)

  useEffect(() => {
    setHasValue(!!props.value)
    setHasDisabled(!!props.disabled)
  }, [props.value, props.disabled])

  return (
    <Container
      className={`${hasFocus ? 'has-focus' : ''}${hasValue ? ' has-value' : ''}${
        hasDisabled ? ' has-disabled' : ''
      }`}
    >
      <label>{props.label}</label>
      <Select
        {...props}
        style={{ width: '100%' }}
        data-cy="municipio"
        showSearch
        size="large"
        onFocus={(e) => {
          setHasFocus(true)
          props.onFocus?.(e)
        }}
        onBlur={(e) => {
          setHasFocus(false)
          props.onBlur?.(e)
        }}
        onChange={(value, option) => {
          setHasValue(!!value)
          props.onChange?.(value, option)
        }}
      >
        <Select.Option value={''}>
          <em>{props.titleOption}</em>
        </Select.Option>
        {props.data.map((x) => (
          <Select.Option className="option-select" key={x as any} value={x as any}>
            {x as any}
          </Select.Option>
        ))}
      </Select>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  label {
    color: #484848c9;
    position: absolute;
    font-size: 14px;
    font-weight: 500;
    z-index: 1;
    top: calc(50% - 10px);
    left: 10px;
    transition: all 0.25s;
  }
  &.has-value,
  &.has-focus {
    label {
      top: -9px;
      left: 10px;
      font-size: 12px;
      background-color: #fff;
      padding: 0 3px;
    }
  }
  &.has-disabled {
    label {
      background-color: #f5f5f5;
    }
  }
  .ant-select {
    .ant-select-selector {
      height: 50px !important;
      &:hover,
      &:focus {
        border-color: #eb8d00 !important;
        box-shadow: 0 0 0 2px rgba(235, 141, 0, 0.2) !important;
      }
      .ant-select-selection-search .ant-select-selection-search-input {
        height: 50px;
      }
      .ant-select-selection-item {
        display: flex;
        align-items: center;
      }
    }
  }
`
